module.exports = __webpack_public_path__ + "catalog/items/sofa/sofa.obj";